<!-- Hero Section -->
<section class="relative pt-28 pb-20 bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 text-white">
  <div class="absolute inset-0 pointer-events-none">
    <div class="absolute -left-24 top-10 w-80 h-80 rounded-full bg-blue-600/20 blur-3xl"></div>
    <div class="absolute -right-24 bottom-0 w-96 h-96 rounded-full bg-indigo-600/20 blur-3xl"></div>
  </div>
  <div class="container mx-auto px-4 relative z-10">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <div class="order-2 lg:order-1">
        <div class="inline-flex items-center px-3 py-1 rounded-full bg-emerald-500/10 text-emerald-300 text-xs font-semibold mb-4 border border-emerald-400/30">
          <i class="bx bx-award mr-1 text-sm"></i>
          Enterprise Cloud &amp; DevOps Platform
        </div>
        <h1 class="text-4xl md:text-5xl font-extrabold leading-tight mb-4">
          Modern <span class="text-blue-400">Cloud</span> and
          <span class="text-emerald-300">DevOps</span> for Critical Workloads
        </h1>
        <p class="text-base md:text-lg text-slate-300 mb-6 max-w-xl">
          Run Windows, Linux and GPU workloads on secure Indian datacentres with an integrated
          DevOps platform for CI/CD, observability and automated operations.
        </p>
        <div class="flex flex-col sm:flex-row gap-3 mb-6">
          <a routerLink="/contact" class="inline-flex items-center justify-center px-6 py-3 rounded-lg text-sm font-semibold text-white bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 shadow-lg hover:shadow-xl transition-all duration-300">
            <i class="bx bx-phone-call mr-2 text-base"></i>
            Talk to Cloud Architect
          </a>
          <a routerLink="/devops" class="inline-flex items-center justify-center px-6 py-3 rounded-lg text-sm font-semibold text-blue-200 bg-slate-900/60 hover:bg-slate-800/80 border border-blue-500/40 transition-all duration-300">
            <i class="bx bx-code-block mr-2 text-base"></i>
            Explore DevOps Services
          </a>
        </div>
        <div class="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-2xl">
          <div class="border border-slate-700/70 rounded-lg px-3 py-2 bg-slate-900/60">
            <div class="text-sm font-semibold text-white">16+ Years</div>
            <div class="text-xs text-slate-400">Enterprise Experience</div>
          </div>
          <div class="border border-slate-700/70 rounded-lg px-3 py-2 bg-slate-900/60">
            <div class="text-sm font-semibold text-white">99.99%</div>
            <div class="text-xs text-slate-400">Uptime SLA</div>
          </div>
          <div class="border border-slate-700/70 rounded-lg px-3 py-2 bg-slate-900/60">
            <div class="text-sm font-semibold text-white">550+ </div>
            <div class="text-xs text-slate-400">Cloud Servers</div>
          </div>
          <div class="border border-slate-700/70 rounded-lg px-3 py-2 bg-slate-900/60">
            <div class="text-sm font-semibold text-white">24/7</div>
            <div class="text-xs text-slate-400">Operations Team</div>
          </div>
        </div>
      </div>
      <div class="order-1 lg:order-2">
        <div class="relative rounded-2xl border border-slate-700 bg-slate-900/90 text-white shadow-2xl overflow-hidden">
          <div class="px-5 py-4 border-b border-slate-800 flex items-center justify-between">
            <div class="flex items-center">
              <span class="inline-flex h-9 w-9 rounded-full bg-blue-600 items-center justify-center mr-3">
                <i class="bx bx-cloud text-lg"></i>
              </span>
              <div>
                <div class="text-xs uppercase tracking-wide text-slate-400">Insightful Cloud</div>
                <div class="text-sm font-semibold">Production Cluster</div>
              </div>
            </div>
            <span class="px-2.5 py-1 rounded-full bg-emerald-500/15 text-emerald-300 text-xs font-medium">
              Healthy
            </span>
          </div>
          <div class="px-5 py-4 grid grid-cols-2 gap-4 text-sm">
            <div>
              <div class="flex items-center justify-between mb-1">
                <span class="text-slate-400">Cloud Nodes</span>
                <span class="font-semibold">124</span>
              </div>
              <div class="text-xs text-slate-500">Windows, Linux, GPU</div>
            </div>
            <div>
              <div class="flex items-center justify-between mb-1">
                <span class="text-slate-400">CI/CD Pipelines</span>
                <span class="font-semibold">38</span>
              </div>
              <div class="text-xs text-slate-500">GitOps &amp; automation</div>
            </div>
            <div>
              <div class="flex items-center justify-between mb-1">
                <span class="text-slate-400">Avg. CPU Usage</span>
                <span class="font-semibold">42%</span>
              </div>
              <div class="w-full h-1.5 rounded-full bg-slate-800">
                <div class="h-1.5 rounded-full bg-gradient-to-r from-emerald-400 to-blue-500" style="width: 42%;"></div>
              </div>
            </div>
            <div>
              <div class="flex items-center justify-between mb-1">
                <span class="text-slate-400">Deployments / day</span>
                <span class="font-semibold">95</span>
              </div>
              <div class="w-full h-1.5 rounded-full bg-slate-800">
                <div class="h-1.5 rounded-full bg-gradient-to-r from-indigo-400 to-purple-500" style="width: 70%;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Features Section -->
<section class="py-16 bg-slate-950 border-t border-slate-800/70">
  <div class="container mx-auto px-4">
    <div class="text-center mb-10">
      <div class="inline-block bg-blue-500/10 border border-blue-500/40 text-blue-300 px-4 py-1 rounded-full text-xs font-semibold mb-3">
        Core Products: Cloud &amp; DevOps
      </div>
      <h2 class="text-3xl md:text-4xl font-bold text-white mb-3">
        Enterprise <span class="text-blue-400">Cloud &amp; DevOps Platform</span>
      </h2>
      <p class="text-base md:text-lg text-slate-300 max-w-3xl mx-auto">
        Combine secure Indian cloud infrastructure with an enterprise DevOps platform for CI/CD, observability, and automated operations across all your workloads.
      </p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-10">
      <div class="bg-slate-900/80 rounded-xl shadow-lg p-8 border border-blue-500/70 hover:border-blue-400 hover:-translate-y-1 transition-all duration-300">
        <div class="w-16 h-16 bg-gradient-to-br from-blue-500 to-emerald-500 rounded-xl flex items-center justify-center mb-6">
          <i class="bx bx-infinite text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-semibold text-white mb-2">DevOps Services (Core)</h3>
        <p class="text-slate-300 mb-4 text-sm">
          CI/CD pipelines, GitOps, observability and SRE practices designed for your cloud-native and enterprise applications.
        </p>
        <a routerLink="/devops" class="text-blue-300 font-semibold flex items-center hover:text-blue-200 group text-sm">
          Explore DevOps
          <i class="bx bx-right-arrow-alt ml-2 group-hover:translate-x-1 transition-transform"></i>
        </a>
      </div>

      <div class="bg-slate-900/80 rounded-xl shadow-lg p-8 border border-slate-700/70 hover:border-blue-500/70 hover:-translate-y-1 transition-all duration-300">
        <div class="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center mb-6">
          <i class="bx bx-chip text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-semibold text-white mb-2">GPU Cloud Computing</h3>
        <p class="text-slate-300 mb-4 text-sm">
          High-performance NVIDIA H200, H100, A100 GPUs for AI/ML, deep learning, and high-performance computing workloads.
        </p>
        <a routerLink="/gpu-cloud" class="text-blue-300 font-semibold flex items-center hover:text-blue-200 group text-sm">
          Learn more
          <i class="bx bx-right-arrow-alt ml-2 group-hover:translate-x-1 transition-transform"></i>
        </a>
      </div>

      <div class="bg-slate-900/80 rounded-xl shadow-lg p-8 border border-slate-700/70 hover:border-emerald-500/70 hover:-translate-y-1 transition-all duration-300">
        <div class="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl flex items-center justify-center mb-6">
          <i class="bx bxl-windows text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-semibold text-white mb-2">Windows Cloud</h3>
        <p class="text-slate-300 mb-4 text-sm">
          Fully compatible Windows Server instances with SQL Server options for enterprise applications and workloads.
        </p>
        <a routerLink="/windows-cloud" class="text-emerald-300 font-semibold flex items-center hover:text-emerald-200 group text-sm">
          Learn more
          <i class="bx bx-right-arrow-alt ml-2 group-hover:translate-x-1 transition-transform"></i>
        </a>
      </div>

      <div class="bg-slate-900/80 rounded-xl shadow-lg p-8 border border-slate-700/70 hover:border-amber-400/70 hover:-translate-y-1 transition-all duration-300">
        <div class="w-16 h-16 bg-gradient-to-br from-orange-500 to-amber-600 rounded-xl flex items-center justify-center mb-6">
          <i class="bx bxl-tux text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-semibold text-white mb-2">Linux Cloud</h3>
        <p class="text-slate-300 mb-4 text-sm">
          Optimized Linux distributions with flexible configurations for web applications, development, and more.
        </p>
        <a routerLink="/linux-cloud" class="text-amber-300 font-semibold flex items-center hover:text-amber-200 group text-sm">
          Learn more
          <i class="bx bx-right-arrow-alt ml-2 group-hover:translate-x-1 transition-transform"></i>
        </a>
      </div>

      <div class="bg-slate-900/80 rounded-xl shadow-lg p-8 border border-slate-700/70 hover:border-purple-500/70 hover:-translate-y-1 transition-all duration-300">
        <div class="w-16 h-16 bg-gradient-to-br from-purple-500 to-violet-600 rounded-xl flex items-center justify-center mb-6">
          <i class="bx bx-hdd text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-semibold text-white mb-2">Storage &amp; Backup</h3>
        <p class="text-slate-300 mb-4 text-sm">
          Scalable storage solutions including object storage, block storage, and backup services.
        </p>
        <a routerLink="/storage-cloud" class="text-purple-300 font-semibold flex items-center hover:text-purple-200 group text-sm">
          Learn more
          <i class="bx bx-right-arrow-alt ml-2 group-hover:translate-x-1 transition-transform"></i>
        </a>
      </div>

      <div class="bg-slate-900/80 rounded-xl shadow-lg p-8 border border-slate-700/70 hover:border-cyan-400/70 hover:-translate-y-1 transition-all duration-300">
        <div class="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-xl flex items-center justify-center mb-6">
          <i class="bx bx-server text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-semibold text-white mb-2">Managed IT &amp; SRE</h3>
        <p class="text-slate-300 mb-4 text-sm">
          24/7 expert support, monitoring, and management of your cloud infrastructure and applications.
        </p>
        <a routerLink="/managed-it" class="text-cyan-300 font-semibold flex items-center hover:text-cyan-200 group text-sm">
          Learn more
          <i class="bx bx-right-arrow-alt ml-2 group-hover:translate-x-1 transition-transform"></i>
        </a>
      </div>

      <div class="bg-slate-900/80 rounded-xl shadow-lg p-8 border border-slate-700/70 hover:border-rose-400/70 hover:-translate-y-1 transition-all duration-300">
        <div class="w-16 h-16 bg-gradient-to-br from-red-500 to-rose-600 rounded-xl flex items-center justify-center mb-6">
          <i class="bx bx-shield-quarter text-3xl text-white"></i>
        </div>
        <h3 class="text-xl font-semibold text-white mb-2">Security &amp; Compliance</h3>
        <p class="text-slate-300 mb-4 text-sm">
          Enterprise-grade security solutions including firewalls, DDoS protection, and compliance services.
        </p>
        <a routerLink="/cybersecurity" class="text-rose-300 font-semibold flex items-center hover:text-rose-200 group text-sm">
          Learn more
          <i class="bx bx-right-arrow-alt ml-2 group-hover:translate-x-1 transition-transform"></i>
        </a>
      </div>
    </div>
  </div>
</section>

<!-- Stats Section -->
<section class="py-20 bg-gradient-to-r from-blue-600 to-indigo-700 text-white">
  <div class="container mx-auto px-4">
    <div class="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
      <div>
        <div class="text-4xl md:text-5xl font-bold mb-2">16+</div>
        <div class="text-lg">Years Experience</div>
      </div>
      <div>
        <div class="text-4xl md:text-5xl font-bold mb-2">99.99%</div>
        <div class="text-lg">Uptime SLA</div>
      </div>
      <div>
        <div class="text-4xl md:text-5xl font-bold mb-2">550+</div>
        <div class="text-lg">Servers Ready</div>
      </div>
      <div>
        <div class="text-4xl md:text-5xl font-bold mb-2">24/7</div>
        <div class="text-lg">Expert Support</div>
      </div>
    </div>
  </div>
</section>

<!-- GPU Cloud Section -->
<section class="py-20 bg-slate-950 border-t border-slate-800/60">
  <div class="container mx-auto px-4">
    <div class="text-center mb-16">
      <div class="inline-block bg-blue-500/10 border border-blue-500/40 text-blue-300 px-4 py-1 rounded-full text-sm font-medium mb-4">
        GPU Cloud
      </div>
      <h2 class="text-3xl md:text-4xl font-bold text-white mb-4">
        The GPU Cloud Enterprises <span class="text-blue-400">Trust</span>
      </h2>
      <p class="text-xl text-slate-300 max-w-3xl mx-auto">
        Deploy GPUs in seconds. Scale to 1000+ on demand. Infrastructure that just works.
      </p>
    </div>
    
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
      <!-- NVIDIA H200 -->
      <div class="bg-slate-900/80 rounded-2xl shadow-2xl border border-slate-700/60 p-8 relative overflow-hidden">
        <div class="absolute top-0 right-0 bg-gradient-to-r from-blue-600 to-indigo-700 text-white px-4 py-1 rounded-bl-lg font-bold text-xs tracking-wide">
          Recommended
        </div>
        <div class="text-center mb-6">
          <div class="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center mx-auto mb-4">
            <i class="bx bx-chip text-3xl text-white"></i>
          </div>
          <h3 class="text-2xl font-bold text-white mb-2">NVIDIA H200</h3>
          <div class="text-3xl font-bold text-blue-300 mb-1">Starting from ₹199/hr</div>
          <div class="text-slate-300">Available in: 1x, 2x, 4x, 8x</div>
        </div>
        
        <ul class="space-y-3 mb-8">
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-400 mr-2"></i>
            <span class="text-slate-200">141GB SXM</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-400 mr-2"></i>
            <span class="text-slate-200">30 vCPU</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-400 mr-2"></i>
            <span class="text-slate-200">375GB RAM</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-400 mr-2"></i>
            <span class="text-slate-200">3.2 Tbps InfiniBand</span>
          </li>
        </ul>
        
        <a routerLink="/contact" class="block w-full bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white font-semibold py-3 px-6 rounded-lg text-center transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-xl">
          Contact Sales
        </a>
      </div>
      
      <!-- NVIDIA H100 -->
      <div class="bg-slate-900/70 rounded-2xl shadow-2xl border border-slate-700/60 p-8 relative overflow-hidden">
        <div class="text-center mb-6">
          <div class="w-16 h-16 bg-gradient-to-br from-amber-500 to-orange-600 rounded-xl flex items-center justify-center mx-auto mb-4">
            <i class="bx bx-chip text-3xl text-white"></i>
          </div>
          <h3 class="text-2xl font-bold text-white mb-2">NVIDIA H100</h3>
          <div class="text-3xl font-bold text-blue-300 mb-1">Starting from ₹163/hr</div>
          <div class="text-slate-300">Available in: 1x, 2x, 4x, 8x</div>
        </div>
        
        <ul class="space-y-3 mb-8">
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-400 mr-2"></i>
            <span class="text-slate-200">80GB SXM</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-400 mr-2"></i>
            <span class="text-slate-200">26 vCPU</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-400 mr-2"></i>
            <span class="text-slate-200">250GB RAM</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-green-400 mr-2"></i>
            <span class="text-slate-200">3.2 Tbps InfiniBand</span>
          </li>
        </ul>
        
        <a routerLink="/contact" class="block w-full bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white font-semibold py-3 px-6 rounded-lg text-center transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-xl">
          Contact Sales
        </a>
      </div>
      
      <!-- Coming Soon -->
      <div class="bg-slate-900/60 rounded-2xl shadow-xl border border-slate-700/60 p-8 relative overflow-hidden opacity-80">
        <div class="absolute top-0 right-0 bg-gradient-to-r from-gray-500 to-gray-700 text-white px-4 py-1 rounded-bl-lg font-bold text-xs tracking-wide">
          Coming Soon
        </div>
        <div class="text-center mb-6">
          <div class="w-16 h-16 bg-gradient-to-br from-gray-500 to-gray-700 rounded-xl flex items-center justify-center mx-auto mb-4">
            <i class="bx bx-chip text-3xl text-white"></i>
          </div>
          <h3 class="text-2xl font-bold text-white mb-2">NVIDIA B200</h3>
          <div class="text-3xl font-bold text-slate-400 mb-1">Coming Soon</div>
        </div>
        
        <ul class="space-y-3 mb-8">
          <li class="flex items-center">
            <i class="bx bx-check-circle text-slate-400 mr-2"></i>
            <span class="text-slate-300">192GB HBM3e</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-slate-400 mr-2"></i>
            <span class="text-slate-300">26 vCPU</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-slate-400 mr-2"></i>
            <span class="text-slate-300">250GB RAM</span>
          </li>
          <li class="flex items-center">
            <i class="bx bx-check-circle text-slate-400 mr-2"></i>
            <span class="text-slate-300">3.2 Tbps InfiniBand</span>
          </li>
        </ul>
        
        <button class="block w-full bg-gradient-to-r from-gray-500 to-gray-700 text-white font-semibold py-3 px-6 rounded-lg text-center cursor-not-allowed">
          Contact Sales
        </button>
      </div>
    </div>
  </div>
</section>

<!-- Testimonials Section (hidden for now as requested) -->

<!-- CTA Section -->
<section class="py-20 bg-gradient-to-br from-gray-900 to-blue-900 text-white">
  <div class="container mx-auto px-4 text-center">
    <h2 class="text-3xl md:text-4xl font-bold mb-6">
      Ready to Transform Your Infrastructure?
    </h2>
    <p class="text-xl text-gray-300 mb-10 max-w-3xl mx-auto">
      Experience enterprise-grade cloud infrastructure with competitive pricing and 24/7 expert support.
    </p>
    <div class="flex flex-col sm:flex-row gap-4 justify-center">
      <a routerLink="/contact" class="bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white font-semibold py-3 px-8 rounded-lg transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-xl">
        Get Started Today
      </a>
      <a routerLink="/pricing" class="bg-transparent border-2 border-blue-500 text-blue-300 hover:bg-blue-500/10 font-semibold py-3 px-8 rounded-lg transition-all duration-300">
        View Pricing
      </a>
    </div>
  </div>
</section>

<!-- Newsletter Popup -->
<div *ngIf="showNewsletterPopup" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
  <div class="bg-white rounded-xl shadow-2xl max-w-md w-full transform transition-all duration-300 scale-95 opacity-0 animate-fade-in-up">
    <div class="p-6">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-xl font-bold text-gray-900">Stay Updated</h3>
        <button (click)="closePopup()" class="text-gray-500 hover:text-gray-700">
          <i class="bx bx-x text-2xl"></i>
        </button>
      </div>
      <p class="text-gray-600 mb-6">
        Subscribe to our newsletter for the latest updates, offers, and industry insights.
      </p>
      
      <form (ngSubmit)="onSubmit(newsletterForm)" #newsletterForm="ngForm">
        <div class="mb-4">
          <label for="firstName" class="block text-sm font-medium text-gray-700 mb-1">First Name</label>
          <input 
            type="text" 
            id="firstName" 
            name="firstName" 
            [(ngModel)]="firstName" 
            required
            class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
        </div>
        
        <div class="mb-4">
          <label for="lastName" class="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
          <input 
            type="text" 
            id="lastName" 
            name="lastName" 
            [(ngModel)]="lastName" 
            required
            class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
        </div>
        
        <div class="mb-6">
          <label for="email" class="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
          <input 
            type="email" 
            id="email" 
            name="email" 
            [(ngModel)]="email" 
            required
            class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
        </div>
        
        <div class="mb-4" *ngIf="isError">
          <div class="text-red-600 text-sm">{{ errorMessage }}</div>
        </div>
        
        <div class="mb-4" *ngIf="isSuccess">
          <div class="text-green-600 text-sm">{{ successMessage }}</div>
        </div>
        
        <button 
          type="submit" 
          [disabled]="isSubmitting || isSuccess" 
          class="w-full bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white font-semibold py-3 px-4 rounded-lg transition-colors duration-300 disabled:opacity-50">
          <span *ngIf="!isSubmitting">Subscribe</span>
          <span *ngIf="isSubmitting">Submitting...</span>
        </button>
      </form>
    </div>
  </div>
</div>

<!-- Chat Widget -->
<div class="fixed bottom-6 right-6 z-40">
  <div *ngIf="isChatOpen" class="mb-4 w-80 bg-white rounded-xl shadow-2xl border border-gray-200 overflow-hidden">
    <div class="bg-gradient-to-r from-blue-600 to-indigo-700 text-white p-4">
      <div class="flex justify-between items-center">
        <h3 class="font-semibold">Support Chat</h3>
        <button (click)="toggleChat()" class="text-white hover:text-gray-200">
          <i class="bx bx-x"></i>
        </button>
      </div>
    </div>
    
    <div #chatMessages class="h-80 overflow-y-auto p-4 bg-gray-50">
      <div *ngFor="let message of messages" class="mb-4">
        <div [ngClass]="{
          'text-right': message.sender === 'user',
          'text-left': message.sender === 'bot'
        }">
          <div [ngClass]="{
            'bg-gradient-to-r from-blue-500 to-indigo-600 text-white inline-block rounded-lg px-4 py-2': message.sender === 'user',
            'bg-gray-200 text-gray-800 inline-block rounded-lg px-4 py-2': message.sender === 'bot'
          }">
            {{ message.text }}
          </div>
          <div [ngClass]="{
            'text-xs text-gray-500 mt-1': true,
            'text-right': message.sender === 'user',
            'text-left': message.sender === 'bot'
          }">
            {{ message.time | date:'shortTime' }}
          </div>
        </div>
      </div>
    </div>
    
    <div class="p-4 border-t border-gray-200">
      <div class="flex">
        <input 
          type="text" 
          [(ngModel)]="newMessage" 
          (keyup.enter)="sendMessage()" 
          placeholder="Type your message..." 
          class="flex-1 border border-gray-300 rounded-l-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
        <button 
          (click)="sendMessage()" 
          [disabled]="!newMessage.trim() || isSending"
          class="bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white px-4 py-2 rounded-r-lg disabled:opacity-50">
          <i class="bx bx-send"></i>
        </button>
      </div>
    </div>
  </div>
  
  <button 
    (click)="toggleChat()" 
    class="w-14 h-14 bg-gradient-to-r from-blue-600 to-indigo-700 rounded-full shadow-lg flex items-center justify-center text-white hover:from-blue-700 hover:to-indigo-800 transition-all duration-300 relative">
    <i class="bx bx-message-dots text-xl"></i>
    <span *ngIf="unreadMessages > 0" class="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full h-6 w-6 flex items-center justify-center">
      {{ unreadMessages }}
    </span>
  </button>
</div>
